import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DomainsService } from '../services/domains.service';
import { DOMAIN_TRIAL_ROUTE_FULL_PATH } from '../constants/app-routes.constant';
import { TrialPeriodService } from '../services/trial-period.service';
import { AcceptInvitationService } from '../services/accept-invitation.service';
import { DomainPaginateInterface } from '@shared/interfaces/dto/domain-paginate-interface';

@Injectable({
  providedIn: 'root',
})
export class DomainsGuard {
  public constructor(
    private readonly domainService: DomainsService,
    private readonly router: Router,
    private readonly trialPeriodService: TrialPeriodService,
    private readonly acceptInvitationService: AcceptInvitationService,
  ) {}

  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.acceptInvitationService.acceptInvitationRequest) {
      if (this.acceptInvitationService.getJoinDomainFromInvitationPath) {
        this.router.navigateByUrl(this.acceptInvitationService.getJoinDomainFromInvitationPath);
      }

      return true;
    }

    const domains: DomainPaginateInterface = this.domainService.getDomainsSessionStorage();
    if (domains.values.length == 0) {
      this.domainService.getDomains().subscribe((data: DomainPaginateInterface) => {
        if (data.paginate.totalDatas == 0) {
          globalThis.location.href = 'https://www.ebp.com/';
        }

        if (this.trialPeriodService.isTrialRequest) {
          const url: string = this.trialPeriodService.createDomainFromPartnerPath ?? DOMAIN_TRIAL_ROUTE_FULL_PATH;

          this.router.navigateByUrl(url);

          return;
        }
      });

      return true;
    }

    [];

    if (this.trialPeriodService.isTrialRequest) {
      this.router.navigateByUrl(DOMAIN_TRIAL_ROUTE_FULL_PATH);

      return true;
    }

    return true;
  }
}
